
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { IAppCoreState } from 'src/app/core/state';
import { Store } from '@ngrx/store';
import { selectAppNotification } from 'src/app/core/state/selectors';
import { IAppNotificationState } from 'src/app/core/state/reducers/app-notification.reducer';
import { DealRoute } from 'src/app/shared/model/api';
import { NavigationExtras, Router } from '@angular/router';
import { AppNotification } from 'src/app/shared/model/api/AppNotification';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import * as appNotificationsActions from '../../../state/actions/app-notification.action';
import { ViewConstants } from 'src/app/constants';
@Component({
  selector: 'con-app-notification-panel',
  templateUrl: './con-app-notification-panel.html',
  styleUrls: ['con-app-notification-panel.scss'],
})
export class ConAppNotificationPanel implements OnInit, OnDestroy {
  private readonly _subs = new SubSink();
  public notifications: IAppNotificationState;
  public isToggle: boolean = true;
  darkTheme = false;
  constructor(private readonly _store: Store<IAppCoreState>, private readonly router: Router,private readonly sharedDataService: SharedDataService) {
  }

  public ngOnInit() {
    this.darkTheme = this.sharedDataService.getDarkThemeValue();
    this._subs.sink = this._store.select(selectAppNotification).subscribe(o => {
      setTimeout(() => {
        if(this.notifications.notificationsList.length==0){
        if(document.getElementById("crossIcon"))
        {
          document.getElementById("crossIcon").focus();
        }
      }
      else if(document.getElementById("NotificationCard0"))
          {
            document.getElementById("NotificationCard0").focus();
          }
     }, 500);
      this.notifications = { ...o };
      this.isToggle=o.isToggle;
      if(!this.isToggle)
      {
        this.notifications.notificationsList=this.notifications.notificationsList
        .filter(element=>(element.deal.reviewManager!=null && element.deal.reviewManager.length>0 && element.deal.reviewManager
        .filter(e => e.id.toString().toLowerCase() === this.sharedDataService.loggedInUserId.toString().toLowerCase()).length > 0))
        .filter(e => e.deal.onlineStatus.toLowerCase() != ViewConstants.ONLINE_STATUS_READY_FOR_DEALER.toLowerCase())
      }
    });
   
  }

  public ngOnDestroy() {
    this._subs.unsubscribe();
  }

  public close() {
    this._store.dispatch(appNotificationsActions.AppNotificationHidePanel());
  }

  public clearAll() {

    if (this.notifications?.notificationsList?.length > 0) {
      this._store.dispatch(appNotificationsActions.AppNotificationClearAll());
    }
  }
  //
  // navigate to writeup-details
  //
  public navigateToWriteup(item: AppNotification) {
    let navExtra = this.getNavigationExtras(item);
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(['wd/writeup-detail'], navExtra);
    this.close();
  }

  //
  // return data required for navigating to writeup-details module
  //
  private getNavigationExtras(data: AppNotification) {

    let dealRoute: DealRoute = {};
    if(data.customer){
      dealRoute.customer = data.customer.firstName + data.customer.lastName;
    }
    dealRoute.dealType = data.deal.writeupType;
    dealRoute.dealStatus = data.deal.status;
    dealRoute.dealTransactionId = data.deal.dealTransactionId;
    dealRoute.salesConsultant = data.deal.salesPerson;
    dealRoute.isNotification = true;
    dealRoute.timestamp = Date.now();
    let navigationExtras: NavigationExtras = {
      // queryParams: {
      //   "dealRoute": JSON.stringify(dealRoute)
      // },
      skipLocationChange: false,
      state: dealRoute
    };

    return navigationExtras;
  }

  onChangeToggleEvent(event) {
    if(event)
    {
      this._store.dispatch(appNotificationsActions.AppNotificationToggleOn());
    }
    else{
      this._store.dispatch(appNotificationsActions.AppNotificationToggleOff());
    }
  }
}

